"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.addQuestions = void 0;
const deleteQuestion_1 = __importDefault(require("./deleteQuestion"));
const processDB_1 = require("./processDB");
function addQuestions(db, afterQId, newQs, afterQuestion = true) {
    var _a;
    const afterQ = db.questions[afterQId];
    const parentListId = afterQ === null || afterQ === void 0 ? void 0 : afterQ.parentListId;
    const parentList = db.lists[parentListId];
    // Remove any empty questions from parentList
    parentList === null || parentList === void 0 ? void 0 : parentList.childQIds.forEach(qId => {
        var _a;
        if (!((_a = db.questions[qId]) === null || _a === void 0 ? void 0 : _a.title))
            (0, deleteQuestion_1.default)(db, qId, true);
    });
    let idx = (afterQ === null || afterQ === void 0 ? void 0 : afterQ.parentListIdx) + 1;
    if (afterQuestion && ((_a = afterQ === null || afterQ === void 0 ? void 0 : afterQ.title) === null || _a === void 0 ? void 0 : _a.trim()) === '') {
        parentList === null || parentList === void 0 ? void 0 : parentList.childQIds.splice(afterQ === null || afterQ === void 0 ? void 0 : afterQ.parentListIdx, 1);
        idx = idx - 1;
    }
    const reversedQs = [...newQs].reverse();
    reversedQs.forEach(newQ => {
        (0, processDB_1.processQuestion)(db, newQ);
        parentList === null || parentList === void 0 ? void 0 : parentList.childQIds.splice(idx, 0, newQ.qId);
    });
    (0, processDB_1.processListParent)(db, parentList);
}
exports.addQuestions = addQuestions;
exports.default = addQuestions;
